import { AdminLayout, useSource, useTranslation } from "@opendash/core";
import { AdminToolbar } from "@opendash/ui";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import * as React from "react";
import { useEffect, useState } from "react";
import {
  MeanTimeBeforeFailure,
  MeanTimeToRecovery,
  MeanTimeToRepair,
} from "../../features/stats";
import {
  Kanban_State,
  Ticket_Kanban_State_Current,
  Ticket_Source,
} from "../../js/parsegenerated";

// TODO: Mean time to repair (MTTR1) => half done
// TODO: Mean time to recovery (MTTR2) => done
// TODO: Mean time to resolve (MTTR3) => todo
// TODO: Mean time to respond (MTTR4) => todo
// TODO: Mean time to acknowledge (MTTA) => even possible?
// TODO: Mean time to failure (MTTF) => todo
// TODO: Mean time between failuren (MTBF) => done
// TODO: Pareto analysis

// TODO: Improve fetching of data by fetching here and passing it down to the components
export const StatisticsPage = observer(() => {
  const t = useTranslation();
  const [source] = useSource();
  const [ticketEndStates, setTicketEndStates] = useState<
    Ticket_Kanban_State_Current[]
  >([]);

  // fetch finished tickets and filter by source
  useEffect(() => {
    async function fetchFinishedTickets() {
      if (!source) return;

      const ticketStateQuery = new Parse.Query(Ticket_Kanban_State_Current)
        .includeAll()
        .descending("updatedAt")
        .matchesKeyInQuery(
          "state",
          "objectId",
          new Parse.Query(Kanban_State)
            .equalTo("isFinished", true)
            .equalTo("enabled", true)
        );

      // we now have all finished tickets, up to 100 as default limit
      const finishedTicketStates = await ticketStateQuery.find();

      const filteredTickets: Ticket_Kanban_State_Current[] = [];
      // filter them by source and issue category
      for (const ticketState of finishedTicketStates) {
        // check source
        const ticketSource = await new Parse.Query(Ticket_Source)
          .equalTo("ticket", ticketState.get("ticket"))
          .first();

        // if source is not the same, skip
        if (ticketSource?.get("source")?.id !== source.id) continue;

        filteredTickets.push(ticketState);
      }

      setTicketEndStates(filteredTickets);
    }

    fetchFinishedTickets();
  }, [source]);

  return (
    <AdminLayout contentPadding>
      <AdminToolbar title={t("maintenance:stats.headline")} />
      <div className="od-page-main">
        <MeanTimeToRepair ticketEndStates={ticketEndStates} />
        <MeanTimeToRecovery ticketEndStates={ticketEndStates} />
        <MeanTimeBeforeFailure ticketEndStates={ticketEndStates} />
      </div>
    </AdminLayout>
  );
});
